const TOAST_EVENT = 'mstore:toast'

const fire = (severity, message) => {
  if (typeof window === 'undefined' || !message) return
  window.dispatchEvent(
    new CustomEvent(TOAST_EVENT, { detail: { severity, message } })
  )
}

const toast = {
  success: (message) => fire('success', message),
  error: (message) => fire('error', message),
  info: (message) => fire('info', message),
  warning: (message) => fire('warning', message),
}

export { TOAST_EVENT }
export default toast
